import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'emit-data-gyh',
    templateUrl: '../../templates/partials/emitGYH-bill.html'
})

export class EmitGYHBillComponent implements OnInit {

    @Input() emitData;
    constructor(private router: Router) { }

    public goToCleaner(id: string) {
        this.router.navigate(['/cleaners', id]);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/emitGYH-bill.component.ts